// extracted by mini-css-extract-plugin
module.exports = {"header1":"DetailedConsumption_header1__3zmy4","header2":"DetailedConsumption_header2__3J8G1","periodSelector":"DetailedConsumption_periodSelector__2nLA5"};